//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentNameDisplayItem } from './StudentNameDisplayItem';
import { TeacherCalendarDisplayItem } from './TeacherCalendarDisplayItem';
import { EventCategoryNameDisplayItem } from './EventCategoryNameDisplayItem';
import { EventLocationNameDisplayItem } from './EventLocationNameDisplayItem';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { PricePerParticipantUnit } from './Enums';

export class CalendarBookingDisplayItem extends ItemBase {
    EventID: string | null = null;
    EventSeriesGUID: string | null = null;
    StudentsAttending: StudentNameDisplayItem[] = [];
    StudentID: string | null = null;
    TeacherID: string | null = null;
    Teacher: TeacherCalendarDisplayItem | null = null;
    OriginalTeacherID: string | null = null;
    OriginalTeacher: TeacherCalendarDisplayItem | null = null;
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    Duration: number = 0;
    Description: string | null = null;
    DisplayDescriptionOnCalendar: boolean = false;
    EventCategoryID: string | null = null;
    EventCategory: EventCategoryNameDisplayItem | null = null;
    EventLocationID: string | null = null;
    EventLocation: EventLocationNameDisplayItem | null = null;
    PricePerParticipant: number = 0;
    PricePerParticipantUnit: PricePerParticipantUnit = PricePerParticipantUnit.PackageMinutes;
    HasFutureConflicts: boolean | null = null;
    MaximumNumberOfParticipants: number = 0;
    CurrentNumberAttending: number = 0;
    MakeUpCreditRequired: boolean = false;
    MakeUpCreditAllowed: boolean = false;
    AllDay: boolean = false;
    RepeatDetails: RepeatDetailsItem | null = null;

    constructor(initializer?: Partial<CalendarBookingDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarBookingDisplayItem";
}
